<template>
  <div class="top-banner">
    <div-container>
      <!-- <div class="block">
        <span class="digit">date: {{ dateValue }}</span>
        <span class="digit">now: {{ now }}</span>
      </div> -->
      <div class="block">
        <span class="text">
          <a href="https://alliedinstructionalshop.alliedinstructional.com/" target="_blank">
            Check out our Assistive Products at our online Shop!
          </a>
        </span>
      </div>
    </div-container>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'

export default {
  name: 'top-banner',
  components: {
    DivContainer
  },
  props: {
  },
  data () {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.top-banner {
  position: relative;
  background-color: $color-primary-green;
  color: white;
  text-align: center;

  // .page-content-bg {
  //   // background-image: url(../assets/menubg.jpg);
  //   // background-repeat: no-repeat;
  //   // background-position: top;
  // }

  .block {
    // display: flex;
    // flex-direction: column;
    display: inline-block;
    margin: 8px 4px;
  }

  .text {
    // color: #1abc9c;
    // font-size: 40px;
    // font-family: 'Roboto Condensed', serif;
    font-weight: bold;
    font-size: 1.25em;
    // margin-top:10px;
    // margin-bottom: 10px;
    margin-left: 3px;
    text-align: center;
  }

  a, a:active {
    color: white;
    &:hover {
      color: $color-primary-lightgreen;
    }
  }
}

</style>
